import { NumberToChineseOptions } from './interface';

export function numberToChinese(
  value: number | string,
  rmb = true,
  options?: NumberToChineseOptions,
): string {
  options = Object.assign(
    {
      minusSymbol: 'è´',
      validThrow: false,
    },
    options,
  );
  if (typeof value === 'number') value = value.toString();
  if (!/^-?\d+(\.\d+)?$/.test(value) && options.validThrow)
    throw new Error(`${value} is invalid number type`);
  let integer: number | string, decimal: number | string;
  [integer, decimal] = value.split('.');
  let symbol = '';
  if (integer.startsWith('-')) {
    symbol = options.minusSymbol;
    integer = integer.substr(1);
  }
  if (/^-?\d+$/.test(value)) decimal = null;
  integer = (+integer).toString();
  const unit = {
    num: rmb
      ? ['', 'å£¹', 'è´°', 'å', 'è', 'ä¼', 'é', 'æ', 'æ', 'ç', 'ç¹']
      : ['', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­', 'ä¸', 'å«', 'ä¹', 'ç¹'],
    radice: rmb
      ? [
          '',
          'æ¾',
          'ä½°',
          'ä»',
          'ä¸',
          'æ¾',
          'ä½°',
          'ä»',
          'äº¿',
          'æ¾',
          'ä½°',
          'ä»',
          'ä¸äº¿',
          'æ¾',
          'ä½°',
          'ä»',
          'å',
          'æ¾',
          'ä½°',
          'ä»',
        ]
      : [
          '',
          'å',
          'ç¾',
          'å',
          'ä¸',
          'å',
          'ç¾',
          'å',
          'äº¿',
          'å',
          'ç¾',
          'å',
          'ä¸äº¿',
          'å',
          'ç¾',
          'å',
          'å',
          'å',
          'ç¾',
          'å',
        ],
    dec: ['è§', 'å', 'å', 'æ¯«'],
  };
  if (rmb) value = (+value).toFixed(5).toString();
  let integerRes = '';
  const integerCount = integer.length;
  if (integer === '0' || integerCount === 0) {
    integerRes = 'é¶';
  } else {
    let cnDesc = '';
    for (let i = 0; i < integerCount; i++) {
      const n = +integer[i],
        j = integerCount - i - 1,
        isZero = i > 1 && n !== 0 && integer[i - 1] === '0',
        cnZero = isZero ? 'é¶' : '',
        isEmpptyUnit =
          (n === 0 && j % 4 !== 0) || integer.substr(i - 3, 4) === '0000',
        descMark = cnDesc;
      let cnNum = unit.num[n];

      cnDesc = isEmpptyUnit ? '' : unit.radice[j];
      // ç¬¬ä¸ä½æ¯ä¸å
      if (i === 0 && cnNum === 'ä¸' && cnDesc === 'å') cnNum = '';
      const isChangeEr =
        n > 1 &&
        cnNum === 'äº' && // å»é¤é¦ä½
        ['', 'å', 'ç¾'].indexOf(cnDesc) === -1 && // ä¸è¯»ä¸¤\ä¸¤å\ä¸¤ç¾
        descMark !== 'å'; // ä¸è¯»åä¸¤
      if (isChangeEr) cnNum = 'ä¸¤';
      integerRes += cnZero + cnNum + cnDesc;
    }
  }

  // å°æ°é¨åæ¼æ¥
  let decimalRes = '';
  const decimalCount = decimal ? decimal.toString().length : 0;
  if (decimal === null) {
    decimalRes = rmb ? 'æ´' : '';
  } else if (decimal === '0') {
    decimalRes = 'é¶';
  } else {
    for (let i = 0; i < decimalCount; i++) {
      if (rmb && i > unit.dec.length - 1) break;
      const n = decimal[i],
        cnZero = n === '0' ? 'é¶' : '',
        cnNum = unit.num[n],
        cnDesc = rmb ? unit.dec[i] : '';
      decimalRes += cnZero + cnNum + cnDesc;
    }
  }
  const ret =
    symbol +
    (rmb
      ? integerRes + (decimalRes === 'é¶' ? 'åæ´' : `å${decimalRes}`)
      : integerRes + (decimalRes === '' ? '' : `ç¹${decimalRes}`));
  return ret;
}
